"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var replacePlaceholders_1 = require("../utils/replacePlaceholders");

var TranslationHelper =
/** @class */
function () {
  function TranslationHelper(targetTranslations, fallbackTranslations) {
    this.targetTranslations = {};
    this.fallbackTranslations = {};
    this.targetTranslations = targetTranslations;
    this.fallbackTranslations = fallbackTranslations;
  }

  TranslationHelper.prototype.translate = function (key, placeholders) {
    var translation = this.getTranslation(key);
    return placeholders ? replacePlaceholders_1.replacePlaceholders(placeholders, translation) : translation;
  };

  TranslationHelper.prototype.getTranslation = function (key) {
    return this.targetTranslations[key] || this.fallbackTranslations[key] || key;
  };

  return TranslationHelper;
}();

exports.TranslationHelper = TranslationHelper;